import type { AdminIdentity } from "@player115/contracts";
import { BarChart3, Boxes, ChevronLeft, FileClock, Globe2, LogOut, Menu, PackageCheck, PackageOpen, Settings2, ShieldCheck } from "lucide-react";
import { useState, type ReactNode } from "react";
import { demoMode } from "../api";

export type Screen = "dashboard" | "releases" | "website" | "runtime-components" | "features" | "commerce" | "security" | "system";

const navigation = [
  { id: "dashboard" as const, label: "统计中心", icon: BarChart3 },
  { id: "releases" as const, label: "版本发布", icon: PackageCheck },
  { id: "website" as const, label: "官网发布", icon: Globe2 },
  { id: "runtime-components" as const, label: "组件资源", icon: PackageOpen },
  { id: "features" as const, label: "模块权限", icon: Boxes },
  { id: "commerce" as const, label: "订单结算", icon: FileClock },
  { id: "security" as const, label: "登录安全", icon: ShieldCheck },
  { id: "system" as const, label: "系统状态", icon: Settings2 },
];

export function Shell({ admin, screen, onScreen, onLogout, children }: {
  admin: AdminIdentity;
  screen: Screen;
  onScreen: (screen: Screen) => void;
  onLogout: () => void;
  children: ReactNode;
}) {
  const [navOpen, setNavOpen] = useState(false);
  const selectScreen = (nextScreen: Screen) => {
    onScreen(nextScreen);
    setNavOpen(false);
  };

  return <div className={`control-shell${navOpen ? " nav-open" : ""}`}>
    <aside className="sidebar" id="admin-navigation">
      <div className="brand-lockup"><span><ShieldCheck size={20} /></span><div><strong>115影音</strong><small>远程控制台</small></div></div>
      <nav aria-label="管理导航">
        {navigation.map((item) => <button className={screen === item.id ? "is-active" : ""} type="button" key={item.id} onClick={() => selectScreen(item.id)}><item.icon size={18} /><span>{item.label}</span>{item.id === "commerce" && <em>待接入</em>}</button>)}
      </nav>
      <div className="sidebar-foot"><span className="environment"><i />{demoMode ? "演示数据" : "本地环境"}</span><button type="button" onClick={onLogout}><LogOut size={17} /><span>退出登录</span></button></div>
    </aside>
    <main>
      <header className="topbar">
        <button className="icon-button mobile-menu" type="button" aria-label={navOpen ? "关闭导航" : "打开导航"} aria-controls="admin-navigation" aria-expanded={navOpen} title={navOpen ? "关闭导航" : "打开导航"} onClick={() => setNavOpen((open) => !open)}><Menu size={19} /></button>
        <div className="crumb"><ChevronLeft size={15} /><span>控制台</span></div>
        <div className="admin-identity"><span>{admin.displayName.slice(0, 1).toUpperCase()}</span><div><strong>{admin.displayName}</strong><small>{admin.email}</small></div></div>
        <button className="topbar-logout" type="button" onClick={onLogout}><LogOut size={16} /><span>退出登录</span></button>
      </header>
      <div className="content">{children}</div>
    </main>
    <button className="nav-scrim" type="button" aria-label="关闭导航" onClick={() => setNavOpen(false)} />
  </div>;
}
